(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/services/services.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/services/services.js');

const wrapPromise = (promise) => {
  let status = 'pending';
  let result;
  let suspend = promise.then(
    (res) => {
      status = 'success';
      result = res;
    },
    (err) => {
      status = 'error';
      result = err;
    }
  );
  return {
    read() {
      if (status === 'pending') {
        throw suspend;
      } else if (status === 'error') {
        throw result;
      } else if (status === 'success') {
        return result;
      }
    }
  };
};

const promises = {};

const dataFetch = (options) => {
  const { path } = options;
  if (!path) {
    return;
  }
  if (!promises[path]) {
    promises[path] = wrapPromise(svs.core.jupiter.callAsync(options));
  }
  return promises[path]?.read();
};

class HTTPError extends Error {
  constructor(obj) {
    super(obj.message);
    this.code = obj.code;
    this.reqId = obj.reqId;
  }
}

function parseErrorResponse(response) {
  let params;
  const jsonResp = response && response.responseJSON ? response.responseJSON : null;
  if (jsonResp && jsonResp.error) {
    if (jsonResp.error) {
      if (jsonResp.error.code || jsonResp.error.code === 0) {
        params = {};
        params.code = jsonResp.error.code;
      }
      if (jsonResp.error.requestId) {
        params = params || {};
        params.reqId = jsonResp.error.requestId;
      }
      if (jsonResp.error.message) {
        params = params || {};
        params.message = decodeURI(jsonResp.error.message);
      }
    }
  } else if (jsonResp && jsonResp.status) {
    if (jsonResp.status.code) {
      params = {};
      params.code = jsonResp.status.code;
    }
    if (jsonResp.status.description) {
      params = params || {};
      params.description = jsonResp.status.description;
    }
    if (jsonResp.message) {
      params = params || {};
      params.message = jsonResp.message;
    }
  }
  return params;
}

function callAsync(options) {
  return new Promise((resolve, reject) => {
    svs.core.jupiter.call(options, (response, status, xhr) => {
      resolve({
        response,
        status,
        xhr
      });
    }, xhr => {
      const errObj = parseErrorResponse(xhr);
      reject(new HTTPError(errObj));
    });
  });
}
const getCompanyDetails = async () => {
  const options = {
    method: 'GET',
    path: '/partner/1/admin/companycustomers/0'
  };
  return await svs.core.jupiter.callAsync(options);
};

const getAvailableDeliveryChannels = async (userName) => {
  const options = {
    method: 'GET',
    path: '/partner/1/admin/availabledeliverychannels',
    data: {
      userName
    }
  };
  return await svs.core.jupiter.callAsync(options);
};

const recoverPassword = async ({ userName, deliveryChannel, cellPhone }) => {
  const options = {
    method: 'POST',
    path: '/partner/1/admin/onetimepassword',
    data: {
      userName,
      deliveryChannel,
      cellPhone: deliveryChannel === 'TextMessage' ? cellPhone : undefined
    }
  };
  return await callAsync(options);
};

const passwordRecoveryErrorMapper = (err) => {
  let message;
  const code = err.code;
  switch (code) {
    case 0:
      message = 'Numret matchar inte det registrerade.';
      break;
    case 2:
      message = 'Fel lösenord eller användarnamn.';
      break;
    case 35:
      message = 'Ingen användare med denna e-postadress kunde hittas.';
      break;
    default:
      message = 'Tekniskt fel, var god försök senare.';
  }
  return message;
};

const downloadOrder = async (orderId) => {
  const options = {
    method: 'POST',
    path: '/ticket/1/triss/downloadorderaszip',
    data: {
      orderId
    }
  };
  return await svs.core.jupiter.callAsync(options);
};

const downloadZip = (data, orderId) => {
  if (data?.zipAsBase64) {
    const filename = `${orderId}.zip`;
    const data2 = atob(data.zipAsBase64);
    const data3 = new Uint8Array(data2.length);

    for (let i = 0; i < data2.length; i++) {
      data3[i] = data2.charCodeAt(i);
    }

    const blob = new Blob([data3], { type: 'application/zip' });

    if (window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveBlob(blob, filename);
    } else {
      const elem = window.document.createElement('a');
      elem.href = window.URL.createObjectURL(blob);
      elem.download = filename;
      document.body.appendChild(elem);
      elem.click();
      document.body.removeChild(elem);
    }
  } else if (data?.msg?.indexOf('phone missing') >= 0) {
    svs.ticket_partner.logger.warn('Failed to get zip, partner missing phone number');
    svs.ticket_partner.utils.showErrorDialog('Var vänlig lägg till mobilnummer för mottagande av dekrypteringsnyckel');
  } else {
    svs.ticket_partner.logger.warn('Failed to get zip', data);
    svs.ticket_partner.utils.showErrorDialog();
  }
};

const sendPassword = async (orderId) => {
  const options = {
    method: 'POST',
    path: '/ticket/1/triss/sendpassword',
    data: {
      orderId
    }
  };
  return await svs.core.jupiter.callAsync(options);
};

const changePassword = async (oldPassword, newPassword) => {
  let api = 1;
  if (svs.core.detect.feature('ft-its-api-version')) {
    api = 2;
  }
  const options = {
    method: 'PUT',
    path: `/user/${api}/password`,
    data: {
      oldPassword,
      newPassword
    }
  };
  return await svs.core.jupiter.callAsync(options);
};

const changePasswordErrorMapper = (err) => {
  let message;
  const code = err.code;
  switch (code) {
    case '6 243':
      message = 'Nuvarande lösenord är felaktigt.';
      break;
    case '6 124':
      message = 'Lösenordet kan inte vara samma som tidigare.';
      break;
    case '6 125':
    case '2 108':
    case '6 301':
    case '6 126':
      message = 'Lösenordet måste innehålla 8-18 tecken, varav minst en bokstav och en siffra. Tillåtna tecken: 0-9 a-z A-Z.@-';
      break;
    default:
      message = `Tekniskt fel, var god försök senare. (Felkod: ${code})`;
  }
  return message;
};

const updateCompanyCustomer = async (data) => {
  const options = {
    method: 'POST',
    path: '/partner/1/admin/companycustomers',
    data
  };
  return await svs.core.jupiter.callAsync(options);
};

const mapUpdateCompanyCustomerError = (error) => {
  const code = error.code;
  switch (code) {
    case 21003:
      return 'Den valda E-postadressen är upptagen.';
    case 21004:
      return 'Den valda E-postadressen är ogiltig.';
    default:
      return 'Ett oväntat fel har inträffat.';
  }
};

const orderPhysical = async (data) => {
  const options = {
    method: 'POST',
    path: '/ticket/1/triss/orderphysical',
    data
  };
  return await svs.core.jupiter.callAsync(options);
};

const mapOrderphysicalError = (error) => {
  const code = error.code;
  switch (code) {
    default:
      return 'Ett oväntat fel har inträffat.';
  }
};

const createDigitalOrder = async (data) => {
  const options = {
    method: 'POST',
    path: '/partner/1/admin/applications',
    data
  };
  return await svs.core.jupiter.callAsync(options);
};

const mapDigitalOrderError = (error) => {
  switch (error?.code) {
    case 21003:
      return 'Den angivna mailadressen är redan tagen';
    case 27008:
      return 'Minimum antal för vald produkt är 2 st.';
    default:
      return 'Ett oväntat fel har inträffat.';
  }
};

svs.ticket_partner.services = {
  changePassword,
  changePasswordErrorMapper,
  recoverPassword,
  passwordRecoveryErrorMapper,
  getAvailableDeliveryChannels,
  getCompanyDetails,
  dataFetch,
  downloadZip,
  downloadOrder,
  sendPassword,
  updateCompanyCustomer,
  mapUpdateCompanyCustomerError,
  orderPhysical,
  mapOrderphysicalError,
  createDigitalOrder,
  mapDigitalOrderError
};


 })(window);